// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { ProductFamily } from './ProductFamily'
import { ProductName } from './ProductName'


export const FilterComboProductFamilyName = ({ family, name, onFamilyChange, onNameChange, disabled, disableFamilyChoice, disableNameChoice, inline, style }) => (
  <div className="sidebar__item slds-p-around_large" style={style}>
    <ProductFamily
      value={family}
      onChange={onFamilyChange}
      disabled={disabled || disableFamilyChoice}
      inline={inline}
    />
    <ProductName
      value={name}
      family={family}
      onChange={onNameChange}
      disabled={family === '' || disabled || disableNameChoice}
      inline={inline}
    />
  </div>
)

FilterComboProductFamilyName.propTypes = {
  family: PropTypes.string,
  name: PropTypes.string,
  onFamilyChange: PropTypes.func.isRequired,
  onNameChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  disableFamilyChoice: PropTypes.bool,
  disableNameChoice: PropTypes.bool,
  inline: PropTypes.bool,
  style: PropTypes.object
}

FilterComboProductFamilyName.defaultProps = {
  inline: true
}



// WEBPACK FOOTER //
// ./src/components/filter-combo-payment-family-name/index.js